export default __webpack_public_path__ + "static/media/Specc-Logo-St.31f9abdc.svg";